import React from 'react'
import { Redirect, Route } from 'react-router-dom'

import { useAuth } from "../helper"

function PrivateRoute({ component: Component, headerTitle, ...rest }) {
  const isAuthenticated = useAuth()
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <div>
            <Component {...props} />
          </div>
        ) : (
          <div>
            <Redirect to="/" />
            <Component {...props} />
          </div>

        )
      }
    />
  )
}

export default PrivateRoute
